export default __webpack_public_path__ + "static/media/clearsky.ccae97df.jpg";